import {
  Box,
  Center,
  Flex,
  Heading,
  Text,
  Stack,
  Avatar,
  useColorModeValue
} from '@chakra-ui/react';
import Link from 'next/link';
import { SaneImage } from '@components/sanity/sane-image';
import { urlForImage } from '@lib/sanity';
import { DocsTutorialContent } from '@types';

type Props = {
  post: DocsTutorialContent;
};

export default function PostCard(props: Props) {
  const { post } = props;

  return (
    <Center py={1}>
      <Link legacyBehavior href={post.slug} passHref>
        <Flex
          as="a"
          layerStyle="linkCard"
          direction={'column'}
          w={'full'}
          h="full"
          bg="var(--cardBg)"
          p={0}
          overflow={'hidden'}
          _hover={{
            boxShadow: useColorModeValue('dropShadow2', 'dropShadow1')
          }}
        >
          <Box
            h="157px"
            bg="var(--bodyBg)"
            pos={'relative'}
            display={{ base: 'none', xl: 'block' }}
          >
            {/* @ts-ignore */}
            <SaneImage
              layout="fill"
              alt={post.title}
              src={post.coverImage}
              height={undefined}
              width={undefined}
              wrapClassName={undefined}
            />
          </Box>

          <Stack justify="space-between" flex={1} p={6}>
            <Stack>
              <Text
                color="var(--secondaryTextColor)"
                textTransform={'uppercase'}
                fontWeight={700}
                textStyle="xs-semibold"
                letterSpacing={1.1}
              >
                {post.category}
              </Text>
              <Heading size="2xs" color="var(--primaryTextColor)">
                {post.title}
              </Heading>
              <Text color="var(--secondaryTextColor)" textStyle="xs-normal">
                {post.excerpt}
              </Text>
            </Stack>
            <Stack
              mt={'auto'}
              pt={4}
              direction={'row'}
              spacing={4}
              align={'center'}
            >
              <Avatar
                src={urlForImage(post.author.picture.asset).url() as string}
                name={post.author.name}
              />
              <Text
                color="var(--primaryTextColor)"
                fontSize={'sm'}
                fontWeight={600}
              >
                {post.author.name}
              </Text>
            </Stack>
          </Stack>
        </Flex>
      </Link>
    </Center>
  );
}
